import React from 'react';
import { Plane, Car, Users, Mountain, Crown, MapPin, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const icons = [Plane, Car, Users, Mountain, Crown, MapPin];

const ServicesSection = () => {
  const { t } = useLanguage();
  return (
    <section id="services" className="py-24 bg-[#0a0a0a] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#ff6b1a] text-sm font-bold tracking-[0.2em] uppercase">{t.services.tag}</span>
          <h2 className="text-4xl md:text-5xl font-black text-white mt-3 mb-4">{t.services.title}</h2>
          <p className="text-white/60 max-w-3xl mx-auto text-lg">{t.services.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.services.items.map((s, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="glass-card rounded-xl p-8 card-hover group cursor-pointer">
                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#ff6b1a] to-[#ff8533] flex items-center justify-center mb-5 shadow-lg shadow-orange-500/20 group-hover:scale-110 transition-transform">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{s.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed mb-5">{s.desc}</p>
                <a href="#reservation" className="inline-flex items-center gap-1.5 text-[#ff6b1a] font-semibold text-sm hover:gap-3 transition-all">
                  {t.services.seeMore} <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
